<div *ngIf="show" [translate]="message" [translateParams]="params"></div>
